// HeroSection.jsx
import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import "../styles/hero1.css";
import Typewriter from "typewriter-effect";
import { Link } from 'react-router-dom';
import {FaCalendarAlt} from 'react-icons/fa';

const HeroSection = () => {
  return (
    <>
      <section className="education-hero my-5 py-3">
        {/* Left Content */}
        <div className="education-hero-content">
          <p className="text-white fw-bold"></p>
          <h5 className="education-hero-subtitle text-white fs-5 py-2">
            A Quality Education For Empowering Students And Professionals...
          </h5>
          <span className="fw-bold text-white fs-5">Guided By IITian's</span>
          
          <h1 className="education-hero-title text-black mt-3">
            Holistic Education through<br />
            Innovative Learning Approaches
          </h1>

          <p className="education-hero-description text-white fw-semibold">
            Powered by <span className="text-warning px-2 py-1 fw-bold fs-4 text-decoration-underline">IIT Expertise</span>,
            our comprehensive e-learning platform delivers world-class training and online coaching designed to transform educational experiences.
          </p>

          <p className="education-hero-description text-white fw-semibold">
            We combine cutting-edge digital learning technologies with expert-curated content, enabling students to unlock their full potential through flexible, high-quality educational solutions that bridge academic excellence and professional success.
          </p>

          {/* Buttons */}
          <div className="education-hero-buttons mt-4 mb-3">
            <Link to="/admission" className="education-hero-btn education-hero-btn-start">
              Get Admission
            </Link> 
            <Link to="/enroll" className="education-hero-btn education-hero-btn-watch">
              Register/Enroll
            </Link>
            <Link to="/course_brochures" className="education-hero-btn education-hero-btn-broh">
              Brochures
            </Link>
          </div>
        </div>

        {/* Right Side - Animation & Typewriter */}
        <div className="education-hero-right">
          {/* Typewriter Section */}
          <div className="typewriter-section">
            <Typewriter
              options={{
                strings: [
                  "IIT-JEE & NEET Medical Training!",
                  "Master Full-Stack Development!",
                  "Quantum Computing Specialist Courses!",
                  "Space Tech & Satellite Engineering!",
                  "AI/ML & Agentic AI Developer!",
                  "Data Science & Analytics Expert!",
                  "Study Abroad: GRE | TOEFL | IELTS | GMAT!",
                  "Paid Internships & Real Projects!",
                  "Cloud Computing: AWS, Azure, GCP!",
                  "Blockchain & Web3 Development!",
                  "Robotics & IoT Engineering!",
                  "DSA & Competitive Programming!",
                  "Mobile App Development!",
                  "Cyber Security & Ethical Hacking!",
                  "DevOps & CI/CD Automation!",
                  "More On Demand High Paying Jobs ..."
                ],
                autoStart: true, 
                loop: true,
                delay: 50,
                deleteSpeed: 40,
              }}
            />
          </div>

          {/* Lottie Animation */}
          <div className="lottie-animation">
            <DotLottieReact
              src="https://lottie.host/acdab1c6-a8f3-44b4-9de0-fdabb3dd474f/KJIagiJmUu.lottie"
              loop
              autoplay
            />
          </div>

          {/* Book Consultation Button */}
          <div className="consultation-btn-wrapper">
            <Link to="/book-consultation" className="btn-book-consultation">
              <FaCalendarAlt /> Book Free Consultation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;